import script from "./TaskItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskItemList.vue?vue&type=script&setup=true&lang=js"

import "./TaskItemList.vue?vue&type=style&index=0&id=f08d0532&lang=css"

const __exports__ = script;

export default __exports__